import React, { useState } from "react";
import {
  Autocomplete,
  TextField,
  InputAdornment,
  IconButton
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const SearchBar = ({ data, searchKeys, onSearch, placeholder = "Search..." }) => {
  const [searchValue, setSearchValue] = useState("");

  const filterData = (value) => {
    return data.filter((item) =>
      searchKeys.some((key) =>
        item[key]?.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const handleInputChange = (event, value, reason) => {
    setSearchValue(value);
    if (value === "") {
      onSearch(data); // Reset to full data when cleared
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      const filtered = searchValue ? filterData(searchValue) : data;
      onSearch(filtered);
      event.preventDefault(); // Prevent input from being cleared
    }
  };

  const handleOptionSelect = (event, newValue) => {
    if (newValue) {
      const label = typeof newValue === "string"
        ? newValue
        : getOptionLabel(newValue);
      setSearchValue(label);
      onSearch(filterData(label));
    }
  };

  const getOptionLabel = (option) => {
    if (typeof option === "string") return option;
    const key = searchKeys[0];
    return option[key] || "";
  };

  return (
    <Autocomplete
      freeSolo
      options={filterData(searchValue)}
      getOptionLabel={getOptionLabel}
      inputValue={searchValue}
      onInputChange={handleInputChange}
      onChange={handleOptionSelect}
      filterOptions={(x) => x}
      clearOnBlur={false}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder={placeholder}
          onKeyDown={handleKeyDown}
          sx={{
            width: 250,
            bgcolor: "#343a40",
            "& .MuiOutlinedInput-root": {
              height: "35px",
              minHeight: "35px",
              padding: "10px !important",
              "& input": {
                padding: "4px 8px",
                height: "20px !important",
                fontSize: "0.8rem",
                color: "#fff"
              },
              "& fieldset": {
                borderColor: "#6c757d"
              },
              "&:hover fieldset": {
                borderColor: "#adb5bd"
              },
              "&.Mui-focused fieldset": {
                borderColor: "#90caf9"
              }
            }
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start" sx={{ height: "30px" }}>
                <IconButton
                  edge="start"
                  size="small"
                  sx={{ padding: "0", height: "24px", width: "24px" }}
                >
                  <SearchIcon sx={{ color: "#fff", fontSize: "16px" }} />
                </IconButton>
              </InputAdornment>
            )
          }}
        />
      )}
    />
  );
};

export default SearchBar;
